import {
  Box,
  FormField,
  NonCancelableCustomEvent,
  Tiles,
  TilesProps,
} from '@amzn/awsui-components-core';
import React, { Component } from 'react';
import constants from '../../../common/constants';
interface Props {
  onInputUpdated?: (sectionId: string, selectedTile: string, validationError?: string) => void;
  onValidationError?: (validationError?: string) => void;
  sectionId?: string;
  label: string;
  description?: string;
  info?: React.ReactNode;
  readonly?: boolean;
  isRequired?: boolean;
  disabled?: boolean;
  showValidationError?: boolean;
  tileOptions: any[];
  selectedTile: string;
  stretch?: boolean;
  placeholder?: string;
  visible?: boolean;
}

interface State {
  selectedTile: string;
  validationError?: string;
}

class MetadataTileInput extends Component<Props, State> {
  static defaultProps = {
    description: '',
    disabled: false,
    isRequired: false,
    placeholder: '',
    readonly: false,
    showValidationError: true,
    stretch: false,
    visible: true,
  };

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.state = {
      selectedTile: props.selectedTile,
    };
  }

  public componentDidUpdate(prevProps: Props, prevState: State) {
    if (
      this.props.selectedTile !== prevProps.selectedTile &&
      this.props.selectedTile !== this.state.selectedTile
    ) {
      this.setState({
        selectedTile: this.props.selectedTile,
      });
      this.validateInput(this.props.selectedTile);
    }

    if (prevProps.showValidationError && !this.props.showValidationError) {
      this.setState({
        validationError: undefined,
      });
    }
  }

  public render() {
    const {
      readonly,
      label,
      description,
      info,
      stretch,
      tileOptions,
      isRequired,
      visible,
      showValidationError,
    } = this.props;
    const { selectedTile, validationError } = this.state;
    if (!visible) {
      return null;
    } else if (readonly) {
      return selectedTile ? (
        <div>
          <span>
            <Box variant="strong">{label}:</Box> {this.getItemLabel(selectedTile)}
          </span>
        </div>
      ) : null;
    } else {
      return (
        <FormField
          errorText={showValidationError && validationError}
          label={
            label && (
              <>
                {label}
                {!isRequired && <i> - optional</i>}
              </>
            )
          }
          description={description}
          info={info}
          stretch={stretch}
          i18nStrings={{ errorIconAriaLabel: 'Error' }}
        >
          <Tiles
            value={selectedTile}
            items={tileOptions}
            onChange={this.handleInput}
            ariaRequired={isRequired}
          />
        </FormField>
      );
    }
  }

  private handleInput = (e: NonCancelableCustomEvent<TilesProps.ChangeDetail>) => {
    const value: string = e.detail.value;
    const error = this.validateInput(value);

    this.setState({
      selectedTile: value,
      validationError: error,
    });

    const { sectionId, onInputUpdated: onUpdated } = this.props;

    if (sectionId && onUpdated) {
      onUpdated(sectionId, value, error);
    }
  };

  private validateInput = (value: string) => {
    const { isRequired, onValidationError } = this.props;

    let error: string;

    if (isRequired && !value) {
      error = constants.REQUIRED;
    }

    if (onValidationError) {
      // @ts-expect-error TS2454 - strict migration
      onValidationError(error);
    }

    // @ts-expect-error TS2454 - strict migration
    return error;
  };

  private getItemLabel = (value: string) => {
    const { tileOptions } = this.props;
    const item = tileOptions.find((o) => o.value === value);
    return item ? item.label : '';
  };
}

export default MetadataTileInput;
